module.exports = __webpack_public_path__ + "teqbahn-assets/media/Node.0f52a6a0.png";